import { render, staticRenderFns } from "./EsCreateButton.vue?vue&type=template&id=b38d93ca&scoped=true&"
import script from "./EsCreateButton.vue?vue&type=script&lang=ts&"
export * from "./EsCreateButton.vue?vue&type=script&lang=ts&"
import style0 from "./EsCreateButton.vue?vue&type=style&index=0&id=b38d93ca&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38d93ca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsButton: require('/app/src/components/common/EsButton.vue').default,EsTooltip: require('/app/src/components/common/EsTooltip.vue').default})
